import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const cocReportColumns: GridColumnConfig[] = [
  {
    title: 'Customer Name',
    field: 'customerName',
    filter: 'text',
    width: '230',
    searchable: true,
  },
  {
    title: 'Office Name',
    field: 'officeName',
    filter: 'text',
    width: '230',
    searchable: true,
  },
  {
    title: 'Project Name',
    field: 'projectName',
    filter: 'text',
    width: '230',
    searchable: true,
  },
  {
    title: 'Jobsite',
    field: 'jobsite',
    filter: 'text',
    searchable: true,
    width: '230',
  },
  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    width: '230',
    searchable: true,
  },
  {
    title: 'Market Area',
    field: 'marketAreas',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Project Department',
    field: 'projectDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Unit Department',
    field: 'unitDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Status',
    field: 'cocStatus',
    filter: 'text',
    width: '200',
    searchable: true,
  },
  {
    title: 'Download CoC',
    field: 'coCDownladURL',
    filter: 'text',
    width: '160',
    searchable: true,
  },
  {
    title: 'Updated Date',
    field: 'updatedDate',
    filter: 'text',
    width: '200',
    searchable: true,
  },
  {
    title: 'Upload CoC',
    field: 'coCUploadURL',
    filter: 'text',
    width: '140',
    searchable: true,
  },
  {
    title: 'Download Signed CoC',
    field: 'coCSignedURL',
    filter: 'text',
    width: '200',
    searchable: true,
  },
  {
    title: 'Send Mail',
    field: 'cocMailSend',
    filter: 'text',
    width: '200',
    searchable: true,
  },
];
